export var isSubStep = function (step) {
    return typeof step.parentId !== 'undefined';
};
export var isStep = function (step) {
    return !isSubStep(step);
};
export var isStepWithSubSteps = function (step) { return isStep(step) && !!step.subSteps; };
